import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit {

  @Input() minValue: number;
  @Input() maxValue: number;
  @Input() name: string;
  @Input() slug: string;

  constructor() { }

  ngOnInit(): void { }

}
